import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { ContentWrapperCustomerApp } from '../Layouts/ContentWrapperCustomerApp';
import { CustomerHeaderNav } from '../Layouts/CustomerHeaderNav';

export const TemporaryProblemsScreen = () => (
  <div className='min-h-screen bg-primary-background-gradient'>
    <CustomerHeaderNav />
    <ContentWrapperCustomerApp hideBackButton width='lg'>
      <div className='mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center p-4 text-center md:p-10'>
        <NoddiBasicCard className='flex flex-col gap-5'>
          <div className='flex flex-col items-center gap-4'>
            <NoddiIcon name='TriangleAlert' size='large' className='text-warningDark' />
            <h2 className='text-2xl font-semibold'>
              <Trans>Looks like we hit a flat!</Trans>
            </h2>
          </div>
          <p className='text-muted-foreground'>
            <Trans>
              We're experiencing some temporary problems and our team is working to get things rolling again. No need to
              re-tire just yet — we'll be back on track shortly.
            </Trans>
          </p>
          <p className='text-sm text-muted-foreground'>
            <Trans>Thank you for your patience while we patch things up.</Trans>
          </p>
        </NoddiBasicCard>
      </div>
    </ContentWrapperCustomerApp>
  </div>
);
